import React, { useMemo, useState , useEffect} from "react";
import { useAuthenticated } from "../hooks/useAuthenticated";
import { useLocation, Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useCookies } from "react-cookie";
import { useDispatch } from "react-redux";
import { fetchAccessData } from "../store/slices/accessSlice";

const AuthGuard = (props) => {
  const dispatch = useDispatch();
  const [cookies] = useCookies(["va",'euid']);

  const { children, allowed } = props;
  const auth = useAuthenticated();
  // const auth = true
  const location = useLocation();

  const [requestedLocation, setRequestedLocation] = useState();

  // const hasPermission = useMemo(() => {
    
  //   let currentRoute = routePermissions.find(rp => rp.route === location.pathname);

  //   if (!currentRoute) {
  //     currentRoute = routePermissions.find(rp => {
  //       const regex = new RegExp(`^${rp.route?.replace(/\/:.*$/, '/[^/]+')}$`);
  //       return regex.test(location.pathname);
  //     });
  //   }
  
  //   // If still no match, check for a prefix match
  //   if (!currentRoute) {
  //     currentRoute = routePermissions
  //       .filter(rp => location.pathname?.startsWith(rp.route))
  //       .sort((a, b) => b.route.length - a.route.length)[0];
  //   }
  
  //   return currentRoute ? currentRoute.permission : true;
  // }, [location.pathname, routePermissions]);

  // if (!hasPermission) {
  //   return <Navigate to="/dashboard/not-found" />; // Redirect to a "no access" page
  // }


  useEffect(() => {
    if(cookies.euid){
      dispatch(fetchAccessData(cookies.euid));
    }
  }, [dispatch, cookies.euid]);


  if (!auth) {



    const params = new URLSearchParams(location.search);
    const accessedFrom = params.get("accessedFrom")?.replace(/['"]+/g, "").trim(); // Remove any quotes
    

    
    if (accessedFrom === "email") {
      // Store the full location object for redirect after login
      localStorage.setItem("requestedLocation", JSON.stringify(location));
    }
    

    // //so that this path can be opened after logging in 
    // localStorage.setItem('requestLocation',requestedLocation)
    return <Navigate to="/auth" />;
  }
  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
